import { render, staticRenderFns } from "./KnAuthorizationMiniGradeItem.vue?vue&type=template&id=959bedb6&scoped=true"
import script from "./KnAuthorizationMiniGradeItem.js?vue&type=script&lang=js&external"
export * from "./KnAuthorizationMiniGradeItem.js?vue&type=script&lang=js&external"
import style0 from "./KnAuthorizationMiniGradeItem.vue?vue&type=style&index=0&id=959bedb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959bedb6",
  null
  
)

export default component.exports